interface IErrorResponse {
  Code: string;
  Message: string;
  StackTrace: string;
  InnerErrors: IErrorResponse[];
}

export interface IErrors {
  Errors: IErrorResponse[];
}

export interface ICommonError {
  errorCode: string;
  defaultErrorMessage: string;
  useServerMessage: boolean;
}

const CommonError: ICommonError[] = [
  {
    errorCode: 'validation-error',
    defaultErrorMessage: 'Validation Error',
    useServerMessage: true,
  },
  {
    errorCode: 'authentication-error',
    defaultErrorMessage: 'Authentication Error',
    useServerMessage: false,
  },
  {
    errorCode: 'authorization-error',
    defaultErrorMessage: 'Authorization Error',
    useServerMessage: true,
  },
  {
    errorCode: 'invalid-operation',
    defaultErrorMessage: 'Invalid Operation',
    useServerMessage: true,
  },
  {
    errorCode: 'server-error',
    defaultErrorMessage: 'Server Error',
    useServerMessage: false,
  },
  {
    errorCode: 'external-error',
    defaultErrorMessage: 'External Error',
    useServerMessage: true,
  },
  {
    errorCode: 'resource-not-found',
    defaultErrorMessage: 'Resource Not Found',
    useServerMessage: false,
  },
  {
    errorCode: 'subscription-error',
    defaultErrorMessage: 'Subscription Error',
    useServerMessage: false,
  },
  {
    errorCode: 'devices-limit-exhausted',
    defaultErrorMessage: 'Devices Limit Exhaused',
    useServerMessage: false,
  },
  {
    errorCode: 'browser-limit-exhausted',
    defaultErrorMessage: 'Browser Limit Exhaused',
    useServerMessage: false,
  },
  {
    errorCode: 'screens-limit-exhausted',
    defaultErrorMessage: 'Screens Limit Exhausted',
    useServerMessage: false,
  },
  {
    errorCode: 'invalid-session-token',
    defaultErrorMessage: 'Invalid Session Token',
    useServerMessage: false,
  },
  {
    errorCode: 'setting-error',
    defaultErrorMessage: 'Getting Settings Failed',
    useServerMessage: false,
  },
  {
    errorCode: 'revoked-user',
    defaultErrorMessage:
      'Your session has expired or been invalidated. Please sign in again to continue.',
    useServerMessage: false,
  },
  {
    errorCode: 'order-error',
    defaultErrorMessage: 'Failed to create order.',
    useServerMessage: true,
  },
  {
    errorCode: 'deleted-user',
    defaultErrorMessage:
      'This account has been deleted and is no longer active.',
    useServerMessage: true,
  },
  {
    errorCode: 'role-disabled',
    defaultErrorMessage:
      'Your role has been disabled. Please contact an administrator.',
    useServerMessage: true,
  },
  {
    errorCode: 'history-error',
    defaultErrorMessage: 'History could not be loaded.',
    useServerMessage: true,
  },
  {
    errorCode: 'organization-not-found',
    defaultErrorMessage: 'Organization Not Found',
    useServerMessage: true,
  },
  {
    errorCode: 'organization-already-exists',
    defaultErrorMessage: 'Organization Already Exists',
    useServerMessage: true,
  },
  {
    errorCode: 'organization-error',
    defaultErrorMessage: 'Organization Error',
    useServerMessage: false,
  },
  {
    errorCode: 'organization-order-not-found',
    defaultErrorMessage: 'Order Not Found',
    useServerMessage: true,
  },
  {
    errorCode: 'organization-order-invalid-state',
    defaultErrorMessage: 'Order Cannot Be Changed',
    useServerMessage: true,
  },
  {
    errorCode: 'organization-order-error',
    defaultErrorMessage: 'Order Error',
    useServerMessage: true,
  },
  {
    errorCode: 'organization-subscription-not-found',
    defaultErrorMessage: 'Subscription Not Found',
    useServerMessage: true,
  },
  {
    errorCode: 'organization-user-conflict',
    defaultErrorMessage: 'Users Are Being Changed',
    useServerMessage: true,
  },
  {
    errorCode: 'organization-user-error',
    defaultErrorMessage: 'Users Could Not Be Updated',
    useServerMessage: true,
  },
  {
    errorCode: 'organization-subscription-disabled',
    defaultErrorMessage:
      'Your account is managed by your organization and the subscription has been disabled. Please contact your organization.',
    useServerMessage: true,
  },
];

export const getDefaultError = (errorCode: string): ICommonError | null => {
  return CommonError.find((err) => err.errorCode === errorCode) || null;
};

export enum AuthServiceErrorCodes {
  OTPSend = 'otp-send-error',
  OTPVerify = 'otp-verify-error',
  OTPQuotaExceeded = 'otp-quota-exceeded',
}

export enum UserServiceErrorCodes {
  Subscription = 'subscription-error',
}
